import { render, staticRenderFns } from "./AIPPT.vue?vue&type=template&id=50223ad4&scoped=true&"
import script from "./AIPPT.vue?vue&type=script&lang=js&"
export * from "./AIPPT.vue?vue&type=script&lang=js&"
import style0 from "./AIPPT.vue?vue&type=style&index=0&id=50223ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50223ad4",
  null
  
)

export default component.exports